{
  "version": 1,
  "attentionExitSentence": "Attention required — this does not clear on its own.",
  "attentionOwnerSentence": "Attention required — this does not clear on its own.",
  "attentionAmSentence": "Attention required — this does not clear on its own.",
  "attentionEscalatePlaceholder": "Why this needs attention (required)",
  "families": [
    {
      "id": "month-close",
      "reason": "close-blocked",
      "subjectPrefix": "Month-close blocked — ",
      "clearMode": "system",
      "clearingAction": "automatic",
      "resolvedBy": "system:close-complete",
      "writer": "prepareResolvePendingCloseBlockersStmt",
      "writerFile": "ingest-worker/src/pipeline_api.ts",
      "exitKind": "close-lifecycle",
      "exitSentence": "Clears automatically when the close succeeds.",
      "ownerSentence": "Clears automatically when the close succeeds.",
      "amSentence": "Clears automatically when the close succeeds.",
      "escalatePlaceholder": "Why you can't wait for the automatic clear (required)"
    },
    {
      "id": "period-reopened",
      "reason": "close-blocked",
      "subjectPrefix": "Period reopened — re-close required — ",
      "clearMode": "system",
      "clearingAction": "month-end-close",
      "resolvedBy": "system:close-complete",
      "writer": "prepareResolvePendingCloseBlockersStmt",
      "writerFile": "ingest-worker/src/pipeline_api.ts",
      "exitKind": "close-lifecycle",
      "exitSentence": "Clears automatically when the close succeeds.",
      "ownerSentence": "This month was reopened and needs closing again. It clears automatically when the month-end close closes it again; you cannot close it from here.",
      "amSentence": "This month was reopened and needs closing again. It clears automatically when the month-end close closes it again; you cannot close it from here.",
      "escalatePlaceholder": "Why you can't wait for the automatic clear (required)"
    },
    {
      "id": "closed-period-write",
      "reason": "close-blocked",
      "subjectPrefix": "Closed-period write blocked — ",
      "clearMode": "system",
      "clearingAction": "ledger-only",
      "resolvedBy": "system:period-reopened",
      "writer": "prepareResolveClosedPeriodWriteBlockersOnReopenStmt",
      "writerFile": "ingest-worker/src/pipeline_api.ts",
      "exitKind": "closed-period-write",
      "exitSentence": "Clears automatically when the period is reopened (system:period-reopened).",
      "ownerSentence": "Reopening the period is not possible in the console. This has to be added in the ledger by hand for now. It clears automatically when the period is reopened.",
      "amSentence": "Reopening the period is not possible in the console. This has to be added in the ledger by hand for now. It clears automatically when the period is reopened.",
      "escalatePlaceholder": "Why you can't wait for the automatic clear (required)"
    },
    {
      "id": "missing-account-id",
      "reason": "close-blocked",
      "subjectPrefix": "Missing Plaid account_id — ",
      "clearMode": "system",
      "clearingAction": "automatic",
      "resolvedBy": "system:processing-mark",
      "writer": "prepareMappingBlockerClearStmts",
      "writerFile": "ingest-worker/src/pipeline_api.ts",
      "exitKind": "mapping-clear",
      "exitSentence": "Clears automatically once the account is mapped and the transaction processes (system:processing-mark). There is no action on this card.",
      "ownerSentence": "It can't be fixed from the console. It clears on its own when the line is processed again.",
      "amSentence": "It can't be fixed from the console. It clears on its own when the line is processed again.",
      "escalatePlaceholder": "Why you can't wait for the automatic clear (required)"
    },
    {
      "id": "unmapped-account",
      "reason": "close-blocked",
      "subjectPrefix": "Unmapped Plaid account — ",
      "clearMode": "system",
      "clearingAction": "ledger-only",
      "resolvedBy": "system:processing-mark",
      "writer": "prepareMappingBlockerClearStmts",
      "writerFile": "ingest-worker/src/pipeline_api.ts",
      "exitKind": "mapping-clear",
      "exitSentence": "Clears automatically once the account is mapped and the transaction processes (system:processing-mark). There is no action on this card.",
      "ownerSentence": "Mapping this bank account can't be done in the console yet. This has to be added in the ledger by hand for now. It clears when the account is mapped and the line is processed again.",
      "amSentence": "Mapping this bank account can't be done in the console yet. This has to be added in the ledger by hand for now. It clears when the account is mapped and the line is processed again.",
      "escalatePlaceholder": "Why you can't wait for the automatic clear (required)"
    },
    {
      "id": "receipt-match-conflict",
      "reason": "close-blocked",
      "subjectPrefix": "Receipt match conflict — ",
      "clearMode": "system",
      "clearingAction": "automatic",
      "resolvedBy": "system:receipt-match-conflict-cleared",
      "writer": "clearResolvedReceiptMatchConflicts",
      "writerFile": "ingest-worker/src/receipt_context.ts",
      "exitKind": "receipt-match-conflict",
      "exitSentence": "Clears automatically when the conflict is gone.",
      "ownerSentence": "Clears automatically when the conflict is gone.",
      "amSentence": "Clears automatically when the conflict is gone.",
      "escalatePlaceholder": "Why you can't wait for the automatic clear (required)"
    },
    {
      "id": "unmatched-hub-gl",
      "reason": "close-blocked",
      "subjectPrefix": "Unmatched hub GL batch — ",
      "clearMode": "system",
      "clearingAction": "automatic",
      "resolvedBy": "system:hub-gl-mark",
      "writer": "clearUnmatchedHubGlBlockers",
      "writerFile": "ingest-worker/src/pipeline_api.ts",
      "exitKind": "unmatched-hub-gl",
      "exitSentence": "Clears automatically when the hub GL batch is allocated and marked processed.",
      "ownerSentence": "Clears automatically when the hub GL batch is allocated and marked processed.",
      "amSentence": "Clears automatically when the hub GL batch is allocated and marked processed.",
      "escalatePlaceholder": "Why you can't wait for the deposit to allocate (required)"
    },
    {
      "id": "hub-gl-push-refused",
      "reason": "close-blocked",
      "subjectPrefix": "Hub GL push refused — ",
      "clearMode": "system",
      "clearingAction": "automatic",
      "resolvedBy": "system:hub-gl-push-accepted",
      "writer": "prepareClearHubGlPushRefusedStmt",
      "writerFile": "ingest-worker/src/hub_push_refusal.ts",
      "exitKind": "hub-gl-push-refused",
      "exitSentence": "Clears automatically when a later hub GL push for this period is accepted and stored (system:hub-gl-push-accepted).",
      "ownerSentence": "Clears automatically when a later hub GL push for this period is accepted and stored.",
      "amSentence": "Clears automatically when a later hub GL push for this period is accepted and stored.",
      "escalatePlaceholder": "Why you can't wait for the automatic clear (required)",
      "comment": "R27O-4=A (owner 2026-08-19, bound to docs/briefs/fix-r28c.md). The refused payload is never stored, so Books has no source_batch_id for the lost batch and must not persist payload bytes to invent one (no grant; Law 2). Owner accepted that a later accepted push for the same (company, period) is the replacement event. A different accepted batch in the same period therefore also clears this card. Replay of an already-stored batch, 409 conflict, schema refusal, and a later content refusal do not."
    },
    {
      "id": "hard-match-refuse",
      "reason": "close-blocked",
      "subjectPrefix": "Receipt hard-match refused — ",
      "clearMode": "am-disposition",
      "clearingAction": "console",
      "resolvedBy": null,
      "writer": null,
      "writerFile": null,
      "exitKind": "hard-match-refuse",
      "exitSentence": "Escalate with a note starting with \"keep-bank:\" to keep the bank line — that clears this card on the next match pass.",
      "ownerSentence": "Use Keep bank line with a note starting with \"keep-bank:\" to keep the bank line — that clears this card on the next match pass.",
      "amSentence": "Use Keep bank line with a note starting with \"keep-bank:\" to keep the bank line — that clears this card on the next match pass.",
      "escalatePlaceholder": "keep-bank: why the bank line stands (required)"
    },
    {
      "id": "receipt-match-review",
      "reason": "close-blocked",
      "subjectPrefix": "Receipt match review — ",
      "clearMode": "am-disposition",
      "clearingAction": "console",
      "resolvedBy": null,
      "writer": null,
      "writerFile": null,
      "exitKind": "receipt-match-review",
      "exitSentence": "Confirm the match, pick the right transaction from the candidates, or reject it (the transaction returns to the missing-receipt shelf). Escalate to owner. This card does not clear on its own.",
      "ownerSentence": "Confirm the match, pick the right transaction from the candidates, or reject it; a rejected transaction returns to the missing-receipt shelf. This card does not clear on its own.",
      "amSentence": "Confirm the match, pick the right transaction from the candidates, or reject it; a rejected transaction returns to the missing-receipt shelf. This card does not clear on its own. Ask the owner if you are unsure.",
      "escalatePlaceholder": "Why the owner needs this pairing (required)",
      "comment": "feat-receipt-match-correction. AM may name the correct txn via GET/POST /receipt-match-correction (attachReceipt). reject: still honest when the right txn is not in the list. Categorisation resolve is refused for close-blocked."
    },
    {
      "id": "statement",
      "reason": "statement-blocked",
      "subjectPrefix": "Statement reconciliation blocked — ",
      "clearMode": "conditional",
      "clearingAction": "console",
      "resolvedBy": null,
      "writer": null,
      "writerFile": null,
      "exitKind": "statement",
      "exitSentence": "Clears after statement confirmation and successful assertion dispatch.",
      "ownerSentence": "Clears after the statement is confirmed and the assertion is dispatched.",
      "amSentence": "Clears after the statement is confirmed and the assertion is dispatched.",
      "escalatePlaceholder": "Why you can't wait for statement confirmation (required)"
    },
    {
      "id": "stale-publication",
      "reason": "statement-blocked",
      "subjectPrefix": "Stale published assertion — ",
      "clearMode": "attention",
      "clearingAction": "ledger-only",
      "resolvedBy": null,
      "writer": null,
      "writerFile": null,
      "exitKind": "attention",
      "exitSentence": "Does not clear when you confirm the replacement statement. The published assertion stays until a reviewed correction of that publication (Owner reopen if the period is locked).",
      "ownerSentence": "Does not clear when you confirm the replacement statement. The published assertion stays until a reviewed correction of that publication. If the period is locked, reopening it is not possible in the console. This has to be added in the ledger by hand for now.",
      "amSentence": "Does not clear when you confirm the replacement statement. The published assertion stays until a reviewed correction of that publication. If the period is locked, reopening it is not possible in the console. This has to be added in the ledger by hand for now.",
      "escalatePlaceholder": "Why this published assertion needs Owner attention (required)",
      "comment": "SR-07: SHA-keyed subject, not statementBlockerSubject. Confirm of replacement B must leave this card pending."
    },
    {
      "id": "escrow-balance",
      "reason": "escrow-balance",
      "subjectPrefix": "Escrow balance — ",
      "clearMode": "conditional",
      "clearingAction": "console",
      "resolvedBy": null,
      "writer": null,
      "writerFile": null,
      "exitKind": "escrow-balance",
      "exitSentence": "Record a disbursement here if the books are missing one. This card clears when the ledger matches the servicer figure, not when you submit. Escalate to owner if you cannot correct the books. Send to practice asks them — this card returns still open.",
      "ownerSentence": "Record a disbursement here if the books are missing one. This card clears when the ledger matches the servicer figure, not when you submit. Send to the hub asks them — this card returns still open.",
      "amSentence": "Record a disbursement here if the books are missing one. This card clears when the ledger matches the servicer figure, not when you submit. Ask the owner if you cannot correct the books. Send to the hub asks them — this card returns still open.",
      "escalatePlaceholder": "Why you cannot correct the books or wait (required)",
      "comment": "feat-am-escrow-disbursement-entry: the card is not a confirm control. Storing the AM entry does not resolve the row. Match POSTs on escrow-balance-todos resolve a pending row (pipeline:escrow-balance-matched)."
    }
  ]
}
